import React from 'react'
import { Card } from 'primereact/card';
import { Col, Row, FormGroup, Input } from 'reactstrap'
import Formatacao from '@/app/util/formatacao'
import {InputTextarea} from 'primereact/inputtextarea';
import { daysBetween } from '@/app/util/datas'


export default class Contrato extends React.Component { 

    render(){

        const { numero, ano, contratado, saac, fundamentacaoLegal, gestor,
                valorContrato, assinatura, viproc,
                inicioVigencia, fimVigencia, inicioExecucao, fimExecucao,
                publicacaoDiario,
        } = this.props.value

        const isContrato = numero;
        const title = isContrato ? "Contrato" : "Despesa sem Contrato"
        const credor = contratado ? `${contratado.numero} - ${contratado.nome}` : ""
        const gestorContrato = gestor ? gestor.nome : ''
        const dataAssinatura = assinatura ? Formatacao.localDate(assinatura) : ''
        const dataVigenciaInicio = inicioVigencia ? Formatacao.localDate(inicioVigencia) : ''
        const dataVigenciaFim = fimVigencia ? Formatacao.localDate(fimVigencia) : ''
        const dataExecucaoInicio = inicioExecucao ? Formatacao.localDate(inicioExecucao) : ''
        const dataExecucaoFim = fimExecucao ? Formatacao.localDate(fimExecucao) : ''
        const dataPublicacao = publicacaoDiario ?   Formatacao.localDate(publicacaoDiario) : ''

        const diasVigencia = daysBetween(inicioVigencia, fimVigencia)
        const diasExecucao = daysBetween(inicioExecucao, fimExecucao)

        return(
            <Card title={title}>
                <Row>
                    { isContrato && 
                        <Col md={3}>
                            <FormGroup>
                                <label htmlFor="inputNumero">Número</label>
                                <Input ref="numero" id="inputNumero" disabled={true} type="text" value={`${numero}/${ano}`} />
                            </FormGroup>
                        </Col>
                    }                    
    
                    <Col md={isContrato ? 6 : 9}>
                        <FormGroup>
                            <label htmlFor="inputCredor">Contratado</label>
                            <Input ref="credor" id="inputCredor" disabled={true} type="text" value={ credor } />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputViproc">N° Processo (VIPROC)</label>
                            <Input id="inputViproc" disabled={true} type="text" ref="viproc" value={viproc} />
                        </FormGroup>
                    </Col>


                </Row>
                <Row>
                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputEstimado">Valor</label>
                            <Input id="inputEstimado" disabled={true} type="text" ref="valor" value={Formatacao.currency(valorContrato)} />
                        </FormGroup>
                    </Col>
                   
                    { saac && 
                        <Col md={3}>
                            <FormGroup>
                                <label htmlFor="inputSacc">SACC</label>
                                <Input id="inputSacc" ref="sacc"
                                        className="form-control" 
                                        disabled={true} type="text" value={saac} />
                            </FormGroup>
                        </Col>
                    }

                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputAssinatura">Assinatura</label>
                            <Input id="inputAssinatura" disabled={true} type="text" ref="assinatura" value={dataAssinatura} />
                        </FormGroup>
                    </Col>

                    {dataPublicacao &&
                        <Col md={3}>
                            <FormGroup>
                                <label htmlFor="inputPublicacao">Publicação em Diário Oficial</label>
                                <Input id="inputPublicacao" disabled={true} type="text" ref="assinatura" value={dataPublicacao} />
                            </FormGroup>
                        </Col>
                    }          
                </Row>
      
                <Row>    
                    <Col md={12}>
                        <FormGroup>
                            <label htmlFor="inputFundamentacao">Fundamentação Legal</label>
                            <InputTextarea id="inputFundamentacao" disabled={true} ref="fundamentacao" style={ {width: '100%'}}  value={fundamentacaoLegal} />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>    
                    <Col md={12}>
                        <FormGroup>
                            <label htmlFor="inputGEstor">Gestor</label>
                            <Input id="inputGEstor" disabled={true} ref="fundamentacao" value={gestorContrato} />
                        </FormGroup>
                    </Col>
                </Row>
    
                <Row>
                    <Col md={2}>
                        <FormGroup>
                            <label htmlFor="inputVigencia">Vigência (Início)</label>
                            <Input id="inputVigencia" disabled={true} type="text" ref="assinatura" value={dataVigenciaInicio} />
                        </FormGroup>
                    </Col>

                    <Col md={2}>
                        <FormGroup>
                            <label htmlFor="inputVigenciaFim">Vigência (Fim)</label>
                            <Input id="inputVigenciaFim" disabled={true} type="text" ref="assinatura" value={dataVigenciaFim} />
                        </FormGroup>
                    </Col>

                    <Col md={2}>
                        <FormGroup>
                            <label htmlFor="inputDiasVigencia">Dias de Vigência</label>
                            <Input id="inputDiasVigencia" disabled={true} type="text" ref="diasVigencia" value={diasVigencia} />
                        </FormGroup>
                    </Col>
                    

                    <Col md={2}>
                        <FormGroup>
                            <label htmlFor="inputVigencia">Execução (Início)</label>
                            <Input id="inputVigencia" disabled={true} type="text" ref="assinatura" value={dataExecucaoInicio} />
                        </FormGroup>
                    </Col>

                    <Col md={2}>
                        <FormGroup>
                            <label htmlFor="inputVigenciaFim">Execução (Fim)</label>
                            <Input id="inputVigenciaFim" disabled={true} type="text" ref="assinatura" value={dataExecucaoFim} />
                        </FormGroup>
                    </Col>

                    <Col md={2}>
                        <FormGroup>
                            <label htmlFor="inputDiasExecucao">Dias de Execução</label>
                            <Input id="inputDiasExecucao" disabled={true} type="text" ref="diasExecucao" value={diasExecucao} />
                        </FormGroup>
                    </Col>

                </Row>
    
               
            </Card>
        )
    }


 }

